import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import StoreProductSKU from './StoreProductSKU'
import { getAssetLink } from './../../helpers/get-asset-link'

const StoreProduct = () => {
  const { product: productUrl } = useParams()

  const product = useSelector((state) =>
    state.shop.products.find((p) => p.productUrl === productUrl),
  )

  const userEmail = useSelector((state) => state.userData?.user?.email)

  return (
    <div className="ctp-store-product">
      {product && (
        <div className="columns">
          <div className="column is-5">
            <div className="ctp-store-product__media">
              <img
                src={getAssetLink({
                  path: 'chitown-default',
                  file: product.image,
                })}
                alt={product.name}
              />
            </div>
          </div>
          <div className="column">
            <div className="ctp-store-product__info">
              <h1>{product.name}</h1>
              <div className="ctp-store-product__description">
                <p>{product.description}</p>
              </div>
            </div>
            <StoreProductSKU product={{ ...product }} userEmail={userEmail} />
          </div>
        </div>
      )}
    </div>
  )
}

export default StoreProduct
